import { useQuery } from 'react-query';
import { getPreferredAgent } from '../../../services/babou';

function listingHasRealtorInfo(listing) {
    const realtor = listing.realtor;
    return realtor && realtor.first_name &&
        realtor.last_name &&
        realtor.license_number &&
        realtor.company &&
        realtor.phone &&
        realtor.email;
}

function listingHasNoRealtorEmail(listing) {
    return listing && listing.realtor && !listing.realtor.email;
}

function makeRealtorRequest(listing) {
    return async function() {
        if(listingHasRealtorInfo(listing) || listingHasNoRealtorEmail(listing)) {
            return listing.realtor;
        } else {
            const realtorEmail = listing?.realtor?.email;
            const realtor = await getPreferredAgent({ email: realtorEmail });
            if(!realtor) {
                return listing?.realtor;
            }
            const preferredProfile = realtor.preferred_profile;
            const agentData = realtor.agent_data;
            return {
                ...preferredProfile,
                email: preferredProfile.email || agentData?.emails[0] || null,
                phone: preferredProfile.phone || agentData?.phone_numbers[0] || null,
                license_number: preferredProfile.licenseNumber || agentData?.license_numbers[0] || null,
                office_phone: preferredProfile.officePhone,
                website: listing.realtor.website,
            };
        }
    };
}

export function useListingRealtor(listing) {
    return useQuery(['listing-realtor', listing?.id], makeRealtorRequest(listing), {
        staleTime: Infinity,
        enabled: Boolean(listing)
    });
}
